import React, {useEffect} from "react";
import {Form, Modal} from "react-bootstrap";
import cogoToast from "cogo-toast";
import { useEnablePlanMutation } from "../../../../../redux/apiSlice";

const EnablePlanModal = ({showEnablePlanModal, onHide, disabledPlanDetails, tableRef}) => {
   

    const [
        enablePlan, // This is the mutation trigger
        {
       
        }, // This is the destructured mutation result
    ] = useEnablePlanMutation()

    const onSubmit = e => {
            e.preventDefault();
            e.stopPropagation();
    
            enablePlan({
                planId: disabledPlanDetails?.planId
            })
            .unwrap()
        .then(() => {
            cogoToast.success("Created 'Enable Plan' Action Successfully")
            onHide()
        })
        }

    return (
        <Modal
            show={showEnablePlanModal}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
            // backdrop={isUnfreezing ? "static" : true}
            // keyboard={!isUnfreezing}
        >
            <Form
                noValidate
                 onSubmit={onSubmit}
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Enable Plan
                    </Modal.Title>
                    <button type="button" className="close" onClick={onHide}>
                        <span aria-hidden="true" className="d-block">×</span>
                        <span className="sr-only">Close</span>
                    </button>
                </Modal.Header>

                <Modal.Body style={{maxHeight: "calc(100vh - 300px)", overflow: "auto"}}>
                    <p>{`Are you sure you want to Enable ${disabledPlanDetails?.planName} plan?`}</p>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        type="button"
                        onClick={onHide}
                        // disabled={isUnfreezing}
                        className="btn btn-light btn-elevate px-4"
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        // disabled={isUnfreezing}
                        className="btn btn-primary btn-elevate px-4 ml-4"
                    >
                        Enable
                    </button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default EnablePlanModal;
